import React from 'react';
import xhr from 'xhr';
import { useSearchParams, useNavigate } from 'react-router-dom';

// El enlace de los correos de campañas trae el tipo (k), el id y un token firmado (t).
// Los enlaces viejos sin token ya no sirven: se le pide a la persona que escriba.
function Unscribe() {
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = React.useState('loading');
  React.useEffect(() => {
    (async () => {
      try {
        await xhr.post('email-subscriptions/unsubscribe', {
          kind: searchParams.get('k'),
          id: searchParams.get('id'),
          token: searchParams.get('t'),
        });
        setStatus('ok');
        setTimeout(() => {
          navigate('/plataforma/ingresar');
        }, 5000);
      } catch (error) {
        setStatus('error');
      }
    })();
  }, [searchParams.get('id')]);
  if (status === 'loading') return <div>Un momento…</div>;
  if (status === 'error')
    return <div>Este enlace ya no es válido. Para dejar de recibir nuestros correos, escríbenos a hola@klazia.com.</div>;
  return <div>Ya no estarás en nuestra lista de emails, espera un momento mientras te redireccionamos</div>;
}

export default Unscribe;
